import { render, staticRenderFns } from "./more.vue?vue&type=template&id=1207d03c&scoped=true&"
import script from "./more.vue?vue&type=script&lang=js&"
export * from "./more.vue?vue&type=script&lang=js&"
import style0 from "./more.vue?vue&type=style&index=0&id=1207d03c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1207d03c",
  null
  
)

export default component.exports